import React, {useState, useEffect, useRef} from 'react'
import {SLowcodeList, STableActions, SActionBtn, SIDRender} from 'shj-components'
import config from './config'
import {useNavigate} from 'react-router-dom'
import {assignDesign} from './assignDesign'
import {Button, message, Popconfirm} from 'antd'
import {useButtonAuth, iiHOC, getAuth} from '@/utils/auth'
import CheckThePhone from '@/components/CheckThePhone'
import dayjs from "dayjs";
import {designerBatchReceive, getInvalidPage} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getRealEstateList} from "@/services/customerServices.ts";
import KeepAlive from "react-activation";
import {getUser} from "shj-utils";
import {openInNewTab} from "@/utils/queryParse.ts";
import {isHeadquarters} from "@/utils/common.ts";

function DesignPublicInfo(props) {
  const {companyId} = getUser()
  const navigate = useNavigate()
  const listRef = useRef<any>()

  useEffect(() => {
    onCompanyChange(companyId)
  }, [companyId]);

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {current, pageSize, query} = values
        if (query.createDate) {
          query.createdTimeStartWith = dayjs(query.createDate[0]).format('YYYY-MM-DD HH:mm:ss')
          query.createdTimeEndWith = dayjs(query.createDate[1]).format('YYYY-MM-DD HH:mm:ss')
          delete query.createDate
        }
        if (query.firstDate) {
          query.firstDateStart = dayjs(query.firstDate[0]).format('YYYY-MM-DD HH:mm:ss')
          query.firstDateEnd = dayjs(query.firstDate[1]).format('YYYY-MM-DD HH:mm:ss')
          delete query.firstDate
        }
        getInvalidPage({params: {pageId: current, pageSize}, data: {...query}}).then(res => {
          resolve(apiData2Table(res))
        })
      } catch {
        reject({success: false})
      }
    })
  }
  const onCompanyChange = (value: any) => {
    if (value) {
      getRealEstateList({orgId: value}).then(res => {
        listRef?.current?.updateSearchData('buildingId', res)
      })
    } else {
      listRef?.current?.updateSearchData('buildingId', [])
    }
  }

  const assignDesignAll = ({selectedRowKeys}: { selectedRowKeys: number[] }) => {
    if (!selectedRowKeys.length) return message.warning('请先选择至少一条数据')
    assignDesign({listRef, ids: selectedRowKeys})
  }
  const receive = (trackPlanIds: number[]) => {
    designerBatchReceive({trackPlanIds}).then(res => {
      message.success(res.message || '领取成功')
        listRef.current.reload()
    })
  }
  const allReceive = ({selectedRowKeys}: { selectedRowKeys: number[] }) => {
    if (!selectedRowKeys.length) return message.warning('请先选择至少一条数据')
    receive(selectedRowKeys)
  }
  const getStatusOptions = () => {
    return Promise.all([
      httpOrgList(),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum'),
    ]).then(resp => {
      return {
        companyList: resp[0],
        typeListArr: resp[1],
      }
    })
  }
  const extension = {
    onSearchReset: () => {
      listRef?.current?.updateSearchData('buildingId', [])
    },
    request: {fetchList, getStatusOptions},
    auth: getAuth(),
    rowKey: 'id',
    events: {onCompanyChange, assignDesignAll},
    customRender: {
      clueIdRender(text: any, record: any, index: any) {
        const label = text
        return (
            <SIDRender
                id={label}
                onClick={() => {
                  openInNewTab(`/saleOp/salesWorkBench/salesWorkBenchDetail/${record.clueId}?authKey=design`)
                }}
            />
        )
      },
      trackIdRender(text: any, record: any, index: any) {
        const label = text
        return (
            <span>{label}</span>
        )
      },
      allReceive(record: any) {
        return iiHOC(
            <Popconfirm title="确认领取吗？" onConfirm={() => allReceive(record)}>
              <Button datareskey="SJBatchHighSeasPoolGet">批量领取</Button>
            </Popconfirm>
        )
      },
      assignDesignAll(record: any) {
        return iiHOC(
            <Button
                onClick={() => {
                  assignDesignAll(record)
                }}
                datareskey="SJBatchHighSeasPoolAssign"
            >
              批量指定分配
            </Button>
        )
      },
      operationCell(text: any, record: any) {
        return (
            <STableActions>
              <SActionBtn
                  auth="SJHighSeasPoolGet"
                  title="确认领取吗？"
                  confirm
                  onClick={() => {
                    receive([record.id])
                  }}
              >
                领取
              </SActionBtn>
              <SActionBtn
                  primary
                  auth="SJHighSeasPoolAssign"
                  onClick={() => {
                    assignDesign({listRef, ids: [record.id]})
                  }}
              >
                指定分配
              </SActionBtn>
            </STableActions>
        )
      },
      checkPhone(text: any, record: any) {
        return (
            <CheckThePhone
                clueId={record.clueId}
                initValue={text}
                auth="DesignPublicInfoViewPhone"
            />
        )
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={{...config, name: props.listConfigName, [isHeadquarters() ? '' : 'searchInitialValues']: {orgId: companyId}}} ref={listRef} {...extension} />
}

export default function DesignPublicInfoPage(props) {
  return <DesignPublicInfo {...props}/>
}
